/* cl-moon (maison-corval): replica do widget Moonbundle do concorrente no buybox (bloco cl_pdp).
   - oferta clicavel (moonbundle-option-active), linhas de variante por unidade (<select> do app) e o dropdown
     desenhado da variante principal (lista com as variantes NOSSAS, sincronizado com os swatches do Focal);
   - brindes: <select> de cor do brinde; clique na foto/titulo do brinde leva ao produto;
   - o form unico do produto ganha __clItems(): a gaveta (cl-cart-drawer.js) adiciona TODOS os itens do kit
     num /cart/add.js; os descontos automaticos da loja deixam brindes gratis / fecham o preco do kit. */
(function () {
  'use strict';
  function norm(s) { return String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9]/g, ''); }
  function boot(host) {
    var mc = host.querySelector('cl-moonbundle-component[data-cl-moon]');
    if (!mc || mc.__cl) return; mc.__cl = true;
    var cfg = {}, P = null;
    try { cfg = JSON.parse(mc.getAttribute('data-cl-moon')); } catch (e) {}
    try { P = JSON.parse(host.querySelector('script[data-cl-product]').textContent).product; } catch (e) {}
    if (!P) return;
    var forms = [].slice.call(host.querySelectorAll('form[action="/cart/add"]'));
    var form = forms.filter(function (f) { return /product-form-main/.test(f.getAttribute('id')); })[0] || forms[0];
    var idInput = form && form.querySelector('input[name="id"]');
    var wraps = [].slice.call(mc.querySelectorAll('.moonbundle-option-wrapper'));
    function byValue(val) {
      return P.variants.filter(function (v) { return norm(v.options[0]) === norm(val) && v.available; })[0]
        || P.variants.filter(function (v) { return norm(v.options[0]) === norm(val); })[0];
    }
    function current() {
      var id = idInput && idInput.value;
      return P.variants.filter(function (v) { return String(v.id) === String(id); })[0] || P.variants[0];
    }
    function activate(w) {
      wraps.forEach(function (x) { var o = x.querySelector('.moonbundle-option'); if (o) o.classList.toggle('moonbundle-option-active', x === w); });
    }
    function activeWrap() { return wraps.filter(function (w) { var o = w.querySelector('.moonbundle-option'); return o && o.classList.contains('moonbundle-option-active'); })[0] || wraps[0]; }

    /* dropdown desenhado (variante principal) */
    function closeLists() { mc.querySelectorAll('.cl-moon-list').forEach(function (l) { l.remove(); });
      mc.querySelectorAll('.moonbundle-dropdown-button[aria-expanded="true"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); }); }
    function setDrop(btn, val) {
      var sp = btn.querySelector('.moonbundle-dropdown-selected span'); if (sp) sp.textContent = val;
      var sw = btn.querySelector('.moonbundle-swatch-indicator'); if (sw && cfg.swatches && cfg.swatches[val] !== undefined) sw.style.backgroundColor = cfg.swatches[val] || '';
    }
    function syncMain(val) {
      var radios = [].slice.call(host.querySelectorAll('input[type="radio"][data-option-position="1"]'));
      radios.forEach(function (r) {
        var lab = host.querySelector('label[for="' + r.id + '"]');
        var txt = lab ? lab.textContent : '';
        if (norm(txt) === norm(val) && !r.checked) { r.checked = true; r.dispatchEvent(new Event('change', { bubbles: true })); }
      });
    }
    mc.addEventListener('click', function (e) {
      var btn = e.target.closest('.moonbundle-dropdown-button');
      var it = e.target.closest('.cl-moon-list [data-val]');
      if (it) {
        e.preventDefault(); e.stopPropagation();
        var b = it.closest('.moonbundle-custom-dropdown').querySelector('.moonbundle-dropdown-button');
        setDrop(b, it.getAttribute('data-val')); closeLists(); syncMain(it.getAttribute('data-val'));
        return;
      }
      if (btn) {
        e.preventDefault(); e.stopPropagation();
        var was = btn.getAttribute('aria-expanded') === 'true'; closeLists(); if (was) return;
        btn.setAttribute('aria-expanded', 'true');
        var ul = document.createElement('ul'); ul.className = 'cl-moon-list'; ul.setAttribute('role', 'listbox');
        var seen = {};
        P.variants.forEach(function (v) {
          var val = v.options[0]; if (seen[val]) return; seen[val] = 1;
          var li = document.createElement('li'); li.setAttribute('role', 'option'); li.setAttribute('data-val', val);
          li.innerHTML = '<span class="cl-moon-sw" style="background:' + ((cfg.swatches || {})[val] || '#ccc') + '"></span><span></span>';
          li.lastChild.textContent = val; if (!v.available) li.classList.add('is-soldout');
          ul.appendChild(li);
        });
        btn.parentNode.appendChild(ul);
        return;
      }
      var gift = e.target.closest('.moonbundle-gift-img-clickable, .moonbundle-gift-footer-text--pip-openable');
      if (gift) {
        var gw = gift.closest('.moonbundle-gift-horizontal');
        var gi = [].indexOf.call(mc.querySelectorAll('.moonbundle-gift-horizontal'), gw);
        var g = (cfg.gifts || [])[gi]; if (g && g.handle) location.href = '/products/' + g.handle;
        return;
      }
      if (e.target.closest('select, option, .moonbundle-variants-box')) return;
      var w = e.target.closest('.moonbundle-option-wrapper');
      if (w) activate(w);
    });
    document.addEventListener('click', function (e) { if (!mc.contains(e.target)) closeLists(); });
    mc.addEventListener('keydown', function (e) {
      if ((e.key === 'Enter' || e.key === ' ') && e.target.classList && e.target.classList.contains('moonbundle-option')) {
        e.preventDefault(); activate(e.target.closest('.moonbundle-option-wrapper'));
      }
    });
    /* swatch do Focal mudou -> rotulo do dropdown acompanha */
    host.addEventListener('change', function (e) {
      if (!e.target.matches('input[type="radio"][data-option-position="1"]')) return;
      setTimeout(function () { var v = current(); mc.querySelectorAll('.moonbundle-dropdown-button').forEach(function (b) { setDrop(b, v.options[0]); }); }, 0);
    });

    if (form) form.__clItems = function () {
      var w = activeWrap(), wi = wraps.indexOf(w), off = (cfg.offers || [])[wi] || { qty: 1 };
      var items = [], cur = current();
      var rows = w ? [].slice.call(w.querySelectorAll('.moonbundle-variant-row')) : [];
      if (rows.length && rows.some(function (r) { return r.querySelector('select'); })) {
        rows.forEach(function (r) { var s = r.querySelector('select'); var v = s ? byValue(s.value) : cur; items.push({ id: (v || cur).id, quantity: 1 }); });
      } else {
        items.push({ id: cur.id, quantity: off.qty || 1 });
      }
      [].slice.call(mc.querySelectorAll('.moonbundle-gift-horizontal')).forEach(function (gw, i) {
        var g = (cfg.gifts || [])[i]; if (!g) return;
        var s = gw.querySelector('select'), vid = null, vs = g.variants || {};
        if (s) Object.keys(vs).forEach(function (t) { if (norm(t) === norm(s.value)) vid = vs[t]; });
        if (!vid) vid = vs[Object.keys(vs)[0]];
        if (vid) items.push({ id: vid, quantity: 1 });
      });
      var merged = {}, out = [];
      items.forEach(function (it) { if (merged[it.id]) merged[it.id].quantity += it.quantity; else { merged[it.id] = { id: it.id, quantity: it.quantity }; out.push(merged[it.id]); } });
      return out;
    };
  }
  function all() { document.querySelectorAll('.cl-pdp-host').forEach(boot); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
  document.addEventListener('shopify:section:load', all);
})();
